module.exports = __webpack_public_path__ + "img/6_02.963fd0da.jpg";